
    import '/home/ec2-user/Youlify-Design/components/statistic/index.en-US.md?watch=parent';
    export const demoIndex = {
  ids: ["statistic-demo-basic","statistic-demo-unit","statistic-demo-animated","statistic-demo-card","statistic-demo-countdown","statistic-demo-component-token"],
  getter: () => import(/* webpackChunkName: "meta__components__en-US" */'/home/ec2-user/Youlify-Design/components/statistic/index.en-US.md?type=demo')
};